module.exports = __webpack_public_path__ + "static/media/happiest-new.d01d5d20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/happiest-new.svg
// module id = 963
// module chunks = 0